export const DELIVERY_PLATFORMS = [
  {
    key: 'lieferando',
    label: 'Lieferando',
    apiField: 'deliveryLieferandoUrl',
    hostSuffix: 'lieferando.de',
  },
  {
    key: 'ubereats',
    label: 'Uber Eats',
    apiField: 'deliveryUbereatsUrl',
    hostSuffix: 'ubereats.com',
  },
  {
    key: 'wolt',
    label: 'Wolt',
    apiField: 'deliveryWoltUrl',
    hostSuffix: 'wolt.com',
  },
];

export const deliveryEnabledField = (platformKey) => {
  const map = {
    lieferando: 'deliveryLieferandoEnabled',
    ubereats: 'deliveryUbereatsEnabled',
    wolt: 'deliveryWoltEnabled',
  };
  return map[platformKey];
};

const canonicalizeDeliveryUrlForValidation = (parsed, platformKey) => {
  if (platformKey !== 'ubereats') {
    return parsed.href;
  }
  const path = parsed.pathname.replace(/\/+$/, '');
  if (!path.includes('/store/')) {
    return parsed.href;
  }
  const clean = new URL(`${parsed.origin}${path}`);
  const diningMode = new URLSearchParams(parsed.search).get('diningMode');
  if (diningMode === 'DELIVERY') {
    clean.searchParams.set('diningMode', 'DELIVERY');
  }
  return clean.href;
};

export const validateDeliveryPlatformUrl = (raw, platformKey) => {
  const platform = DELIVERY_PLATFORMS.find((p) => p.key === platformKey);
  if (!platform) return 'Unbekannte Plattform';

  const trimmed = String(raw || '').trim();
  if (!trimmed) return null;

  const url = trimmed;
  if (!/^https:\/\//i.test(url)) {
    return `${platform.label}: Link muss mit https:// beginnen.`;
  }

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') {
      return `${platform.label}: Link muss mit https:// beginnen.`;
    }
    const host = parsed.hostname.toLowerCase();
    const expected = platform.hostSuffix;
    if (host !== expected && !host.endsWith(`.${expected}`)) {
      return `${platform.label}: Erwartete Domain …${expected}.`;
    }
    const canonicalUrl = canonicalizeDeliveryUrlForValidation(parsed, platformKey);
    if (canonicalUrl.length > 512) {
      return `${platform.label}: Max. 512 Zeichen.`;
    }
    return null;
  } catch {
    return `${platform.label}: Ungültige URL.`;
  }
};

export const normalizeDeliveryPlatformUrlForSave = (raw) => {
  const trimmed = String(raw || '').trim();
  return trimmed || null;
};

export const normalizeCompanyDeliveryPlatformsForSave = (company) => {
  const next = { ...company };
  DELIVERY_PLATFORMS.forEach((platform) => {
    const enabledField = deliveryEnabledField(platform.key);
    const enabled = Boolean(next[enabledField]);
    if (!enabled) {
      next[platform.apiField] = null;
      return;
    }
    const url = String(next[platform.apiField] || '').trim();
    if (!url) {
      throw new Error(`${platform.label}: Link erforderlich.`);
    }
    const message = validateDeliveryPlatformUrl(url, platform.key);
    if (message) {
      throw new Error(message);
    }
    next[platform.apiField] = normalizeDeliveryPlatformUrlForSave(url);
  });
  DELIVERY_PLATFORMS.forEach((platform) => {
    delete next[deliveryEnabledField(platform.key)];
  });
  return next;
};

export const syncDeliveryPlatformEnabledFlags = (company) => {
  const next = { ...company };
  DELIVERY_PLATFORMS.forEach((platform) => {
    const enabledField = deliveryEnabledField(platform.key);
    next[enabledField] = Boolean(String(next[platform.apiField] || '').trim());
  });
  return next;
};
